import { render } from "./EditorialComponent.vue?vue&type=template&id=691c2930"
import script from "./EditorialComponent.vue?vue&type=script&lang=js"
export * from "./EditorialComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__